import styles from './index.less';
import Search from '@/pages/RepairManage/components/Search';
import { Tabs } from 'antd-mobile';
import { useState } from 'react';
import { tabsList } from './config';
import RepairList from '@/pages/RepairManage/components/RepairList';

const RepairManage = () => {
  const [activeKey, setActiveKey] = useState<string>('all');

  const handleTabChange = (key: string) => {
    setActiveKey(key);
  };

  return (
    <div className={styles.container}>
      <Search />
      <Tabs
        onChange={handleTabChange}
        className={styles['container-tab']}
        defaultActiveKey={activeKey}
        activeLineMode={'fixed'}
      >
        {tabsList.map((item) => (
          <Tabs.Tab key={item.value} title={item.label}>
            <RepairList tabsKey={item.value} />
          </Tabs.Tab>
        ))}
      </Tabs>
    </div>
  );
};

export default RepairManage;
